<template>
    <div class="spinner">
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
    </div>
</template>


<script>
export default {
  data(){
      return {
          
      }
  }
}
</script>

<style>

</style>

<style lang="scss">
.spinner {
    text-align: center;
    height: 14px;
}
.spinner > div {
  background-color: #3988FF;
  height: 5px;
  width: 5px;
  border-radius: 50%;
  margin-left: 10px;
  display: inline-block;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}
.spinner .rect2 { 
    animation-delay: -1.1s; 
    }

.spinner .rect3 { 
    animation-delay: -1.0s; 
    }

.spinner .rect4 { 
    animation-delay: -0.8s; 
    }


@keyframes sk-stretchdelay {
    0%, 40%, 100% { 
            opacity: 0.3;
        }
    20% { 
            opacity: 1;
        }  
}

</style>
